import { Box } from '@chakra-ui/react';
import { Icon, Popover } from '@melio/penny';
import { useAnalytics } from '@melio/platform-analytics';
import { Vendor } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

export const AddInvoiceIndictor = ({
  onAddInvoiceClick,
  vendorId,
}: {
  onAddInvoiceClick: () => void;
  vendorId: Vendor['id'];
}) => {
  const { formatMessage } = useMelioIntl();
  const { track } = useAnalytics();

  const handleAddInvoiceClick = () => {
    track('Dashboard', 'Click', {
      Intent: 'add-invoice-to-bill',
      Cta: 'add-invoice',
    });
    onAddInvoiceClick();
  };
  return (
    <Popover
      data-testid={`add-invoice-indicator-tooltip-${vendorId}`}
      actionProps={{
        label: formatMessage('activities.payDashboard.vendorsTab.table.tooltips.addInvoice.action'),
        onClick: handleAddInvoiceClick,
      }}
      description={formatMessage('activities.payDashboard.vendorsTab.table.tooltips.addInvoice.description')}
      triggerEvent="hover"
    >
      <Box
        display="flex"
        alignItems="center"
        color="neutral.darker"
        paddingRight="8px"
        data-testid={`add-invoice-indicator-icon-${vendorId}`}
      >
        <Icon type="info" size="small" color="inherit" />
      </Box>
    </Popover>
  );
};
